import { Tools } from "@comunicare/comunicare-helper";
import { AbstractQuantity, IQuantity, ITranslation, IVitalProfileDefinition } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class Quantity extends AbstractQuantity {
  constructor(data: IQuantity, def?: IVitalProfileDefinition, private translateService?: TranslateService) {
    super(data, def);
  }

  protected getTranslation(name: ITranslation, lang: string, defaultValue: string): string {
    return Tools.getTranslation(name, lang ?? this.translateService?.currentLang, defaultValue);
  }
}
